import React from "react";
import { GoogleLogin } from '@react-oauth/google';
import db from './db';
// GoogleSecurity
// this is a component that displays a "Log in with Google" button if you press the button and use a valid account,
// the call back procedure onChangeConnection this call back will be passed an object with 
//    userName
//    userEmail
//    userPicture
//    userSessionId
//    httpServer ( from .env file property REACT_APP_HTTP_SERVER)
//    connected (boolean)
// you can allso pass a parameter with a valid session id as a parameter to the app
//
// requirements in .env file
//      REACT_APP_GOOGLE_CLIENT_ID
//      REACT_APP_HTTP_SERVER
// https://www.npmjs.com/package/@react-oauth/google
// https://blog.logrocket.com/guide-adding-google-login-react-app/
// https://www.dolthub.com/blog/2022-05-04-google-signin-migration/#:~:text=It%20will%20be%20replaced%20with,30%2C%202022%20for%20new%20applications.
// https://livefiredev.com/in-depth-guide-sign-in-with-google-in-a-react-js-application/
// https://reactjsexample.com/google-oauth2-using-the-new-google-identity-services-sdk-for-react/
//------------------------------------------------------------------------------------
export default class GoogleSecurity extends React.Component {


    getEmptySecurityObject(){
        let emptySecurityObject ={
            userName:undefined,
            userEmail:undefined,
            userPicture:undefined,
            userSessionId:undefined,
            httpServer:process.env.REACT_APP_HTTP_SERVER+"/",
            connected:false,
            systemSettings:{note_type_list:"[]"},
            isSuperUser: false
        };
        return emptySecurityObject;
    }
    // render
    render() {
        let canLogIn=true;
        return(true) ? (
            <div hidden={ !canLogIn }>
                
                <GoogleLogin
                    onSuccess={credentialResponse => {
                        //console.log(credentialResponse);
                        this.handleLogin(credentialResponse);
/*                        window.google.accounts.id.initialize({
                            facility_id: credentialResponse.clientId
                            , callback: this.handleLogin,
                          });                        */
                    }}
                    onError={() => {
                        console.log('Login Failed');
                    }}
                    useOneTap
                    auto_select
                />
                   
            </div>            
        ) :"";
    }

    // handle login
    handleLogin = async googleData => {  

        //console.log("google Data"+JSON.stringify(googleData,null,2));

        // create an empty object
        let securityObject=this.getEmptySecurityObject();

        // if you are passed a security id use it
        const queryParams = new URLSearchParams(window.location.search);
        if(queryParams.get('session_id')){
            console.log(queryParams.get('session_id'));
            securityObject.userSessionId=queryParams.get('session_id');
            securityObject.connected=true;

        } else {

            // query if user is valid
            let http = securityObject.httpServer + "api/v1/auth/google";
            console.log(http);
            let errMessage=`` ;
            if(googleData && googleData.credential){
                //window.alert(googleData.credential);
            } else {
                window.alert('no googleData.credential');
            }
            try{
                errMessage=`Unable to save create body` ;
                let body={
                    //token: googleData.tokenId,
                    token:googleData.credential,
                    credentials: 'same-origin'
                };
                errMessage=`Unable to save google token (${http})` ;
                const res = await fetch( http, {
                    method: "POST",
                    body: JSON.stringify(body),
                    headers: {
                        "Content-Type": "application/json"
                    }
                })

                errMessage="Unable to retreive google token";
                // save data into securityObject
                const data = await res.json()
                if(data.name){
                    securityObject.userName=data.name;
                    securityObject.userEmail=data.email;
                    securityObject.userPicture=data.picture;
                    securityObject.userSessionId=data.sessionId;
                    if( ['ralph@wavedds.com','ash@wavedds.com','saleem@wavedds.com'].indexOf(data.email)>-1){
                        securityObject.isSuperUser=true;
                    }                    
                    db.getSystemSettings( securityObject
                        , async results =>{
                            if(results.fatal){
                                securityObject.connected=false;
                                securityObject.systemSettings = results;
                                window.alert(JSON.stringify(results));
                            } else {
                                securityObject.systemSettings = results;
                                securityObject.connected=true;
                            }
                            if(this.props.onChangeConnection){
                                this.props.onChangeConnection(securityObject);
                            }
                        }
                    );
                                    
                }

                // show alert
                if(data.message){
                    alert(data.message)
                }
            } catch (ex){
                window.alert( errMessage + ":\n" + ex )
            }

        }
        // do call back
        //if(this.props.onChangeConnection){
        //    this.props.onChangeConnection(securityObject);
        //}
      }

    // handle logout
    handleLogout(){

        // create an empty object
        let securityObject=this.getEmptySecurityObject();
        var http = securityObject.server + "api/logout";
        console.log("logging out");
        let obj={
            method: "POST",
            body: JSON.stringify({
            credentials: 'same-origin'
            })
          };
        fetch(http,obj)
            .then((res) => res.json())
            .then((json) => {
                console.log("logging out-2");
            });

        // do call back
        if(this.props.onChangeConnection){
            this.props.onChangeConnection(securityObject);
        }
     }    
}

